import React from 'react';

function Pricing() {
  const pricingPackages = [
    {
      title: "Funeral Coach Service Package",
      price: "$425.00",
      description: "This package includes a funeral coach with a Service Director or Assistant, providing 5 hours of service time from the initial casket pickup to interment at the cemetery or drop-off time.",
      includes: [
        "Services provided locally within a 50-mile radius",
        "Monday through Saturday, 8:00 a.m. to 3:00 p.m.",
        "Services extending beyond 5 hours: $100.00 per hour"
      ],
      additionalCharges: [
        "Beyond 50 miles: $25.00 per every 5th mile",
        "Prior to 7:00 a.m.: $50.00 per hour",
        "After 3:00 p.m.: $75.00",
        "Sundays or holidays: $150.00 to $200.00"
      ],
      note: "Please note that, with the exception of the casket spray, floral arrangements will not be transported in the funeral coach to prevent any damages."
    },
    {
      title: "Floral Transportation with Service Assistant",
      price: "$325.00",
      description: "This includes floral transportation by a Service Assistant locally within a 30-mile radius; Monday through Saturday, between 8:00 a.m. and 3:00 p.m., for up to 4 hours.",
      includes: [
        "Maximum of 15 floral arrangements per vehicle",
        "Service time up to 4 hours",
        "Services extending beyond 4 hours: $75.00 per hour"
      ],
      additionalCharges: [
        "Beyond 30 miles: $20.00 per every 5th mile",
        "Prior to 7:00 a.m.: $50.00 per hour",
        "After 3:00 p.m.: $50.00",
        "Sundays or holidays: $100.00 to $150.00",
        "Additional Service Assistant: $150.00 per person"
      ]
    },
    {
      title: "Floral Transportation without Service Assistance",
      price: "$275.00",
      description: "This service includes the transportation of floral arrangements by uniformed personnel from the service location (such as a Mortuary Chapel or Church) to the cemetery or reception, ensuring the flowers arrive before the family.",
      includes: [
        "Maximum of 15 floral arrangements per vehicle",
        "Services provided locally within a 30-mile radius",
        "No service assistance included"
      ],
      additionalCharges: [
        "Beyond 30 miles: $20.00 per every 5th mile",
        "Additional Personnel: $150.00 per person"
      ]
    },
    {
      title: "Service Personnel",
      price: "$200.00",
      description: "This includes the services of a Service Director or Assistant Monday through Saturday, between 8:00 a.m. and 3:00 p.m., for up to 4 hours.",
      includes: [
        "Service time up to 4 hours",
        "Services extending beyond 4 hours: $75.00 per hour"
      ],
      additionalCharges: [
        "Prior to 8:00 a.m. or after 3:00 p.m.: $50.00 per hour",
        "Sundays or holidays: $100.00 to $150.00"
      ],
      note: "Please note, Morning Light Funeral Services will not provide any service vehicles."
    }
  ];

  return (
    <section id="pricing" className="pricing-section">
      <div className="container">
        <h2 className="section-title">Services & Pricing</h2>
        <p className="pricing-effective-date">Effective as of December 01, 2025</p>

        <div className="pricing-grid">
          {pricingPackages.map((pkg, index) => (
            <div key={index} className="pricing-card">
              <div className="pricing-header">
                <h3>{pkg.title}</h3>
                <p className="price">{pkg.price}</p>
              </div>

              <p className="package-description">{pkg.description}</p>

              <div className="pricing-details">
                <h4>Includes:</h4>
                <ul className="includes-list">
                  {pkg.includes.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>

              {pkg.additionalCharges && pkg.additionalCharges.length > 0 && (
                <div className="pricing-details">
                  <h4>Additional Charges:</h4>
                  <ul className="additional-charges-list">
                    {pkg.additionalCharges.map((charge, i) => (
                      <li key={i}>{charge}</li>
                    ))}
                  </ul>
                </div>
              )}

              {pkg.note && (
                <p className="package-note">{pkg.note}</p>
              )}
            </div>
          ))}
        </div>

        <div className="pricing-footer">
          <div className="footer-note">
            <p><strong>Important Policies:</strong></p>
            <ul>
              <li>Services cancelled within 24 hours of the scheduled service time will incur a cancellation fee of 50% of the original service charge.</li>
              <li>Any service request made within 12 hours of a scheduled service time will be subject to a late notice fee of $75.00.</li>
              <li>Morning Light Funeral Services LLC reserves the right to refuse service to anyone.</li>
              <li>Prices are subject to change without notice.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
